import Vue from 'vue'

const nameMap = {
  'Home': '首页',
  'AdRevenueQuery': '广告收入',
  'SystemConfigManagement': '系统配置',
  'AppInfoManagement': 'App信息管理',
  'NewbieLessonManagement': '新手课堂',
  'UserManagement': '用户管理',
  'UserWithdrawalManagement': '用户提现',
  'WithdrawalOptionManagement': '提现档位配置',
  'AdminManagement': '管理员管理',
  'AdminLoginLog': '系统日志',
  'LeaderLevelManagement': '团长等级配置',
  'InviteReward': '直邀提现奖励',
  'InviteRewardFlowManagement': '奖励明细',
  'RiskManagement': '风控管理',
  'CoinFlowManagement': '金币明细',
  'AdPoolSettlementManagement': '叠包开包流水'
}

const fixedHomePath = '/home'
const fixedHomeTitle = '首页'

function getPageTitle(route) {
  if (route.meta && route.meta.title) return route.meta.title
  if (route.name && nameMap[route.name]) return nameMap[route.name]
  return route.name || route.path
}

function formatView(route) {
  return {
    path: route.path,
    name: route.name,
    title: getPageTitle(route),
    query: route.query ? { ...route.query } : {},
    fullPath: route.fullPath
  }
}

const state = Vue.observable({
  visitedViews: [],
  cachedViews: []
})

function addView(route) {
  if (!route || !route.name) return
  if (route.path === '/login' || route.path === '/') return
  if (route.name === 'DataDashboard') return

  const view = formatView(route)
  const exists = state.visitedViews.some(v => v.path === view.path)

  if (!exists) {
    state.visitedViews.push(view)
  }
}

function removeView(view) {
  for (let i = state.visitedViews.length - 1; i >= 0; i--) {
    if (state.visitedViews[i].path === view.path) {
      state.visitedViews.splice(i, 1)
      break
    }
  }
}

function closeOthers(view) {
  state.visitedViews = state.visitedViews.filter(
    v => v.path === view.path || v.path === fixedHomePath
  )
}

function closeAll() {
  state.visitedViews = state.visitedViews.filter(
    v => v.path === fixedHomePath
  )
}

function toLastView(currentRoute) {
  const latestView = state.visitedViews.slice(-1)[0]
  if (latestView && latestView.fullPath !== currentRoute.fullPath) {
    return latestView
  }
  return null
}

function isFixedHome(path) {
  return path === fixedHomePath
}

export default {
  get visitedViews() {
    return state.visitedViews
  },
  get cachedViews() {
    return state.cachedViews
  },
  addView,
  removeView,
  closeOthers,
  closeAll,
  toLastView,
  isFixedHome,
  getPageTitle,
  fixedHomePath,
  fixedHomeTitle
}
